import {makeAutoObservable} from 'mobx';
import {makeLoggable} from 'mobx-log';

import config from '../config';
import apiService from '../transport/apiService';

import type {RootStore} from './rootStore';

/**
 * General purpose store for lines. Not in mobx state tree
 */
export class SettingsStore {
  private rootStore: RootStore;

  showAppDevelopmentShop!: boolean;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.showAppDevelopmentShop = config.ENV === 'DEV';

    makeAutoObservable(this);
    makeLoggable(this);
  }

  setShowAppDevelopmentShop(value: boolean) {
    this.showAppDevelopmentShop = value;
    apiService.initialise(value ? 'DEV' : undefined);
    this.rootStore.globalStore.reset();
  }
}
